<template>
<div class="pixi-wrapper">
	<div class="pixi-instance"
	     ref="pixi-instance"
		 @dragenter.prevent="onDragEnter"
	     @drop.prevent="onDrop"
	     @dragover.prevent="onDragOver"></div>
	<slot></slot>
</div>
</template>

<script>
import * as PIXI from 'pixi.js';
import Vue from 'vue';

const EventBus = new Vue();

export default {
	data() {
		let renderOptions = {
			resolution: window.devicePixelRatio,
			width: 1900,
			height: 1085,
			preserveDrawingBuffer: true,
			backgroundColor: 0xB0CFFB,
		};

		return {
			renderOptions: renderOptions,
			maxHeight: 900,
			resizedHeight: 900,
			loader: {
				isLoading: false,
				waitingQueue: [],
				inProgressQueue: [],
				doneList: []
			},
			provider: {
				app: null,
				width: renderOptions.width,
				height: renderOptions.height,
				ready: false
			}
		}
	},

	// Allows any child component to `inject: ['provider']` and have access to it.
	provide() {
		return {
			provider: this.provider,
			EventBus: EventBus,
			PIXI
		}
	},

	methods: {
		resizeApp() {

			const ratio = Math.min(
				this.$refs['pixi-instance'].clientWidth / this.renderOptions.width,
				this.maxHeight / this.renderOptions.height
			);

			this.provider.app.stage.scale.x = this.provider.app.stage.scale.y = ratio;

			this.provider.app.renderer.resize(
				Math.ceil(this.renderOptions.width * ratio),
				Math.ceil(this.renderOptions.height * ratio)
			);

			this.provider.ratio = ratio;

			this.resizedHeight = Math.ceil(this.renderOptions.height * ratio);

		},
		createBackground() {
			const backgroundTexture = new PIXI.Texture.fromImage('/assets/img/playsets/background.png');
			const background = new PIXI.Sprite(backgroundTexture);

			background.width = this.renderOptions.width;
			background.height = this.renderOptions.height;

			this.provider.app.stage.addChild(background);
		},

		onDragOver(event) {
			// function is needed for prevent default, this is needed for the drag and drop polyfill
		},

		onDragEnter(event) {
			// function is needed for prevent default, this is needed for the drag and drop polyfill
		},

		loadImages() {

			if (this.isLoading) return;

			this.isLoading = true;

			const loader = PIXI.loader;

			this.loader.inProgressQueue = this.loader.waitingQueue.splice(0, this.loader.waitingQueue.length);

			this.loader.inProgressQueue.forEach(({ imageUrl }) => {
				loader.add(imageUrl, imageUrl);
			});

			loader.load((loader, resources) => {

				while (this.loader.inProgressQueue.length) {
					let loadObj = this.loader.inProgressQueue.shift();
					loadObj.callback(resources[loadObj.imageUrl]);
				}

				this.isLoading = false;

				if (this.loader.waitingQueue.length > 0) {
					this.loadImages();
				}
			});

		},

		loadPlaysetImage(imageUrl, callback) {

			const loader = PIXI.loader;

			if (loader.resources[imageUrl]) {
				callback(loader.resources[imageUrl])
			} else {
				this.loader.waitingQueue.push({ imageUrl: imageUrl, callback: callback });
				this.loadImages();
			}

		},

		getImage() {
			if (!this.provider.ready) {
				return null;
			}

			let canvas = document.getElementsByTagName('canvas')[0];
			let imageElement = new Image();
			imageElement.src = canvas.toDataURL();
			
			return imageElement;
		},

		onDrop(event) {
			let json = event.dataTransfer.getData('json');

			if (!json || !this.provider.app) return;

			json = JSON.parse(json);
			const offset = json.offset;

			let pixPoint = new PIXI.Point();
			this.provider.app.renderer.plugins.interaction.mapPositionToPoint(pixPoint, event.clientX + offset.x, event.clientY + offset.y);

			const localPoint = this.provider.app.stage.toLocal(pixPoint);

			this.$emit('dropped', {
				id: json.id,
				position: {
					x: localPoint.x,
					y: localPoint.y
				}
			});
		},

		setReady() {
			this.provider.ready = true;
			EventBus.$emit('ready');
		}
	},

	mounted() {
		// The application will create a renderer using WebGL, if possible,
		// with a fallback to a canvas render. It will also setup the ticker
		// and the root stage PIXI.Container
		const app = new PIXI.Application(this.renderOptions);
		Object.defineProperty(this.provider, 'app', { value: app, configurable: false });
		//this.provider.app = app;
		this.provider.minLineHeight = this.renderOptions.height - 670;
		app.renderer.autoResize = true;

		this.resizeApp();
		this.createBackground();

		const playsetContainer = new PIXI.Container();
		const utilsContainer = new PIXI.Container();

		playsetContainer.updateLayersOrder = () => {
			playsetContainer.children.sort((a, b) => {
				return a.y - b.y;
			});
		}

		this.provider.playsetContainer = playsetContainer;
		this.provider.utilsContainer = utilsContainer;
		this.provider.loadPlaysetImage = this.loadPlaysetImage;

		app.stage.addChild(utilsContainer);
		app.stage.addChild(playsetContainer);

		// check for window resize event
		window.addEventListener('resize', this.resizeApp);

		// Insert canvas element in DOM
		this.$refs['pixi-instance'].appendChild(app.view);

		this.provider.playsetContainer = playsetContainer;
		this.setReady();
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.resizeApp);
	}
}
</script>

<style lang="scss">
.pixi-instance {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// assets/vue/apps/participate/pixi-stage.vue